export default __webpack_public_path__ + "static/media/VME.0fac5164.png";